import React from 'react';
import {Breadcrumb} from "react-bootstrap";
import {IndexLinkContainer, LinkContainer} from "react-router-bootstrap";
import * as qs from 'query-string';
import * as Acl from "./acl";
import * as Grid from './grid';
import * as Enums from "./enums";
import * as Date from "./date";
import * as Files from "./files";
import * as Party from "./party";

export {Acl};
export {Date};
export {Enums};
export {Files};
export {Grid};
export {qs};
export {Party};

const stubs = {
	'main': 'Fakturito',
	'page': null,
	'tab': null
};

export const setPageTitle = (text, stub = 'page') => {
	stubs[stub] = text;
	document.title = stubs['main']
		+ (stubs['page'] ? ' | ' + stubs['page'] : '')
		+ (stubs['tab'] ? ' | ' + stubs['tab'] : '')
};

export const decimalEqual = (v1, v2) => {
	if (v1 === v2) {
		return true
	}
	if ((v1 * 100).toFixed(0) === (v2 * 100).toFixed(0)) {
		return true
	}
	console.log(v1, v2);
	return false
};

export const formatMoney = (val, decimals = 2, digits = 2) => {
	if (val === null || val === undefined) {
		return null;
	}
	let m = val.toLocaleString(undefined, {
		'maximumFractionDigits': decimals,
		'minimumFractionDigits': digits
	});
	if (m === '-0') {
		return '0'
	}
	return m
};

export const getPartyIds = function (parties) {
	const partyIds = [];
	for (let i = 0; i < parties.length; i++) {
		partyIds.push(parties[i].partyId);
	}
	return partyIds;
};

export const handleResponse = (json, onSuccess) => {
	if (json && json.response && json.response.result === 'OK') {
		onSuccess()
	} else {
		return new Promise((resolve, reject) => reject())
	}
};

export const breadcrumbs = (crumbs) => {
	const items = [];

	let pageTitle = stubs['main'];
	if (crumbs) {
		for (let i = 0; i < crumbs.length; i++) {
			const title = crumbs[i].literal ? crumbs[i].literal : crumbs[i].title;
			if (i + 1 >= crumbs.length) {
				items.push(<Breadcrumb.Item key={i} active>
					{title}
				</Breadcrumb.Item>)
			} else {
				items.push(<LinkContainer key={i} to={crumbs[i].url}>
					<Breadcrumb.Item>
						{title}
					</Breadcrumb.Item>
				</LinkContainer>)
			}
			pageTitle += " | " + title;
		}
	}
	document.title = pageTitle;

	return <Breadcrumb>
		<IndexLinkContainer to="/">
			<Breadcrumb.Item>
				Domů
			</Breadcrumb.Item>
		</IndexLinkContainer>
		{items}
	</Breadcrumb>;
};

export const baseUrl = function () {
	const base = window.location.href.indexOf('#') > 0
		? window.location.href.substring(0, window.location.href.indexOf('#'))
		: window.location.href;
	if (base === 'http://localhost:3000/') {
		return 'http://localhost:8080/fakturito-dev/';
	}
	return base;
};
